define.alias("shared/components/shared/choose-your-upgrade", "settings/components/shared/choose-your-upgrade");